module.exports = __webpack_public_path__ + "static/img/img-dg2.7f57f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-dg2.png
// module id = evld
// module chunks = 0